import React, { useEffect, useState } from 'react';

import { DragHandle } from '@material-ui/icons';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { uniqueId } from 'lodash';

import { useCurrency, useSelector } from 'Hooks';
import { Box } from 'styles/box';

import DragWrapper from './DragWrapper';
import {
  AnimationWrapper,
  DisplayItem,
  ItemSelectBox,
  ItemWrapper,
  Price,
  RemovableItem,
  RemovableItemWrapper,
  RemoveIconWrapper,
} from './styles';
import Field from '../../Form/Field';
import { Heading } from '../../Typography/Heading';

interface Props {
  formId: string;
  valueList: any;
  removeValue: (id) => void;
  selectedValues: string[];
  selectValues: ((values: string) => void) | undefined;
  handleOrderChange?: (value: string[]) => void;
}

const ValueList = ({
  formId,
  valueList,
  removeValue,
  selectedValues,
  selectValues,
  handleOrderChange,
}: Props) => {
  const currency = useSelector((state) => state.currency);
  const { formatAmount } = useCurrency();
  const [idToRemove, setIdToRemove] = useState('');

  useEffect(() => {
    if (idToRemove) {
      setTimeout(() => {
        removeValue(idToRemove);
        setIdToRemove('');
      }, 400);
    }
  }, [idToRemove]);

  const handleKeyDown = (e, id) => {
    if (e.key === 'Enter' || e.key == ' ') {
      setIdToRemove(id);
    }
  };

  const Content = ({ item }) => {
    return (
      <>
        <RemovableItemWrapper>
          {selectValues !== undefined && (
            <ItemSelectBox
              active={selectedValues.includes(item.id)}
              onClick={() => selectValues(item.id)}>
              <CheckIcon htmlColor="white" />
            </ItemSelectBox>
          )}
          <RemovableItem>
            <Box display="flex" alignItems="center" gap="small">
              {handleOrderChange && <DragHandle htmlColor="#b0b3b6" />}
              <Heading level={5} bottom={0}>
                {item.title}
              </Heading>
            </Box>
            {item.price !== null && item.price !== undefined && formId !== 'defaultVariations' && (
              <Price>{formatAmount(item.price)}</Price>
            )}
            <RemoveIconWrapper
              tabIndex={0}
              onClick={() => setIdToRemove(item.id)}
              onKeyDown={(e) => handleKeyDown(e, item.id)}>
              <CloseIcon htmlColor={'var(--colorBlueGray400)'} />
            </RemoveIconWrapper>
          </RemovableItem>
        </RemovableItemWrapper>
        {!handleOrderChange && // Don't enable children here when dragging dropping, that causes a mess because the objects is so big in the UI
          item.items?.map((item) => (
            <DisplayItem key={item.title}>
              <Heading level={5} bottom={0}>
                {item.title}
              </Heading>
            </DisplayItem>
          ))}
      </>
    );
  };

  if (handleOrderChange) {
    return (
      <DragWrapper
        valueList={valueList}
        idToRemove={idToRemove}
        content={Content}
        handleOrderChange={handleOrderChange}
      />
    );
  }

  return valueList.group?.map((item) => (
    <AnimationWrapper removing={idToRemove == item.id} key={uniqueId()}>
      {valueList.label ? (
        <Field label={valueList.label}>
          <Content item={item} />
        </Field>
      ) : (
        <ItemWrapper>
          <Content item={item} />
        </ItemWrapper>
      )}
    </AnimationWrapper>
  ));
};

export default ValueList;
